import { useTranslation } from 'react-i18next';
import './order-header.component.scss';

export const OrderHeader: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="order-header">
            <div className="order-header__icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                    <path d="M16 13H8" /><path d="M16 17H8" /><path d="M10 9H8" />
                </svg>
            </div>
            <div className="order-header__text">
                <h2 className="order-header__title">{t('Create New Order')}</h2>
                <span className="order-header__subtitle">{t('Employment Certificate')}</span>
            </div>
        </div>
    );
};
